import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";
import "./CheckSecretChartPW.css";

const CheckSecretChartPw = ({ isOpen, onPasswordSubmit }) => {
  const [password, setPassword] = useState("");
  const [isCorrectPW, setIsCorrectPW] = useState();

  const token = localStorage.getItem("token");
  const id = localStorage.getItem("id");

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const validPW = async () => {
    if (password === "") {
      showWarningAlert("비밀번호를 입력해주세요.");
    }
    try {
      const response = await axios.post(
        `/api/v1/schart/validate`,
        {
          userId: id,
          password: password,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        setIsCorrectPW(response.data);
        onPasswordSubmit(response.data);
      }
    } catch (error) {
      console.error("validation error:", error);
    }
  };

  const showWarningAlert = (text) => {
    Swal.fire({
      icon: "warning",
      title: "알림",
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="비밀차트-비밀번호 입력 팝업"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: "1px solid #ccc",
          background: "white",
          borderRadius: "4px",
          width: "330px",
          height: "155px",
        },
      }}
    >
      <h2>비밀번호 입력</h2>
      <div className="csc-input-password">
        <input type="password" value={password} onChange={handlePasswordChange} placeholder="비밀번호를 입력하세요." />
        {!isCorrectPW && isCorrectPW !== undefined && <span className="pw-validation-message">비밀번호가 올바르지 않습니다.</span>}
      </div>
      <div className="csc-button-container">
        <button onClick={validPW}>확인</button>
        {/* <button className="red-button" onClick={onClose}>닫기</button> */}
      </div>
    </Modal>
  );
};
export default CheckSecretChartPw;
